<template>
  <div class="vbox">
    <section class="hbox stretch">
      <section class="map-wrap">
        <!--地图-->
        <v-amap></v-amap>
        <!-- rout -->
        <transition :name="transitionName">
          <router-view class="child-view"></router-view>
        </transition>
      </section>
    </section>
  </div>
</template>
<script>
import vAmap from '@/components/Amap'
import listWarp from '@/components/Aside'
import { mapActions, mapGetters } from 'vuex'
export default {
  components: {vAmap, listWarp},
  name: 'hello',
  data () {
    return {
      transitionName: 'slide-left'
    }
  },
  computed: {
    ...mapGetters([
      'area'
    ])
  },
  watch: {
    area () {
      console.log(this.area)
      if (this.area) {
        this.transitionName = 'slide-right'
      } else {
        this.transitionName = 'slide-left'
      }
    },
    lodingbox: function () {
    }
  },
  created () {
    // this.$store.dispatch('getStreet')
  },
  methods: {
    ...mapActions([
    ])
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss" rel="stylesheet/scss">
  @import '../assets/scss/variables';
  @import '../assets/scss/mixins';
  .map-wrap {
    position: relative;
    padding-bottom: 0;
    overflow-x: hidden;
  }

  .child-view {
    position: absolute;
    transition: all .3s cubic-bezier(.55,0,.1,1);
  }
  .slide-left-enter, .slide-right-leave-active {
    opacity: 0;
    -webkit-transform: translate(50px, 0);
    transform: translate(100%, 0);
  }
  .slide-left-leave-active, .slide-right-enter {
    opacity: 0;
    -webkit-transform: translate(-50px, 0);
    transform: translate(-100%, 0);
  }
  #vux_view_box_body {
    padding: 0;
  }
</style>



// WEBPACK FOOTER //
// index.vue?d2f93058